import React, { useMemo } from 'react';
import { Sprite } from '@pixi/react';
import { getGameImages } from '../../../../core/helpers/getGameImages';
import IconBackGround from '../../iconBackGround';

function Collect({ x, y, handleClickButton }) {
  const { spinIconBgSelected, spinIconBgDefault, spinIconBgPressed, collect } = useMemo(() => {
    return getGameImages();
  }, []);

  const additionalBackGroundImages = useMemo(() => {
    return {
      iconBgDefault: spinIconBgDefault,
      iconBgDisabled: spinIconBgDefault,
      iconBgHovered: spinIconBgDefault,
      iconBgPressed: spinIconBgPressed,
      iconBgSelected: spinIconBgSelected,
    };
  }, [spinIconBgDefault, spinIconBgPressed, spinIconBgSelected]);

  return (
    <IconBackGround
      x={x}
      y={y}
      additionalBackGroundImages={additionalBackGroundImages}
      handleSelect={handleClickButton}
    >
      <Sprite texture={collect} scale={0.5} anchor={0.5} />
    </IconBackGround>
  );
}

export default Collect;
